import { Component, AfterViewInit, Input, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as L from 'leaflet';
import 'leaflet.markercluster'; // Import the markercluster plugin
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit, OnChanges, OnInit {

  @Input() markers: any[] = [];
  @Input() showMap: boolean = false;

  localtions: any[] = [];

  private map: L.Map | any;
  private markersCluster = L.markerClusterGroup(); // Use markerClusterGroup instead of layerGroup
  showSearchBar: boolean = false;

  filteredOptions: Observable<any[]> | undefined;
  mapControl = new FormControl();

  ngOnInit(): void {
    this.showSearchBar = window.location.pathname == '/vivere-il-comune/luoghi' ? true : false;
  }

  ngAfterViewInit(): void {

    document.getElementById('main-container')?.scrollIntoView();
    this.initMap();
    setTimeout(() => {
      this.filteredOptions = this.mapControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    }, 0)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['markers'] && this.map) {
      this.localtions = this.markers.map(marker => {
        return { "text": marker.title }
      })
      this.updateMarkers();
    }
  }

  private initMap(): void {
    this.map = L.map('map').setView([51.505, -0.09], 13);
    L.Icon.Default.imagePath = '/assets/images/';

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);
    this.map.addLayer(this.markersCluster); // Add the marker cluster group to the map
    this.updateMarkers();
  }

  private updateMarkers(): void {
    this.markersCluster.clearLayers(); // Clear existing markers from the cluster group
    this.markers.forEach(marker => {
      const newMarker = marker.popup ? L.marker([marker.lat, marker.lng]).bindPopup(marker.popup) : L.marker([marker.lat, marker.lng]);
      this.markersCluster.addLayer(newMarker); // Add new marker to the cluster group
    });
    this.centerMap();
  }

  private centerMap(): void {
    if (this.markers.length) {
      const group = L.featureGroup(this.markers.map(marker => L.marker([marker.lat, marker.lng])));
      this.map.fitBounds(group.getBounds(), { padding: [50, 50] }); // Adjust padding as needed
    }
  }

  private _filter(value: any): string[] {
    value = value.toString();
    const filterValue = value.toLowerCase();
    return filterValue && this.markers.filter(marker => marker.title.toLowerCase().includes(filterValue));
  }

  search(string: any) {
    this.mapControl.setValue(string);
    this.markers.forEach(marker => {
      if (marker.title === string) {
        this.map.fitBounds(L.latLng(marker.lat, marker.lng).toBounds(100));
        const searchMarker = L.marker([marker.lat, marker.lng]).bindPopup(marker.popup);
        searchMarker.addTo(this.map).openPopup(); // Add marker to map directly for search results
      }
    });
    this.mapControl.setValue('');
  }
}
